import { render } from "./HomeDashboardKpi.vue?vue&type=template&id=28a3bd71"
import script from "./HomeDashboardKpi.vue?vue&type=script&lang=js"
export * from "./HomeDashboardKpi.vue?vue&type=script&lang=js"

import "./HomeDashboardKpi.vue?vue&type=style&index=0&id=28a3bd71&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__